import ApiClient from './ApiClient';

export default class GisApi extends ApiClient {
  region (id) {
    return this.get('regions/' + id);
  }

  geocodeByLocation (location) {
    const config = {
      url: 'https://geocode-maps.yandex.ru/1.x/',
      method: 'get',
      params: {
        format: 'json',
        geocode: location
      }
    };

    return this.axios()(config)
      .then(res => res.data)
      .then(data => {
        try {
          const [a, b] = data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
          const [lowerX, lowerY] = data.response.GeoObjectCollection.featureMember[0].GeoObject.boundedBy.Envelope.lowerCorner.split(' ');
          const [upperX, upperY] = data.response.GeoObjectCollection.featureMember[0].GeoObject.boundedBy.Envelope.upperCorner.split(' ');
          const kind = data.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData.kind;
          return {
            bounds: [+lowerX, +lowerY, +upperX, +upperY].join(','),
            point: [+b, +a],
            kind
          };
        } catch (e) {
          return {
            bounds: null,
            point: null,
            kind: null
          };
        }
      });
  }

  address (term, regionId, withLocality, source) {
    return this.axios().get(
      this.prefix + 'address',
      {
        cancelToken: source.token,
        params: {
          q: term,
          regionId,
          withLocality
        }
      }).then(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/api/GisApi.js